import { Routes, Route, Navigate } from 'react-router-dom';
import { RoutesLayout } from './RoutesLayout';
import { RoutesAdmin } from './RoutesAdmin';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * Mapeamento e Gerenciamento Centralizado de Rotas
 */
export function AppRoutes() {
  return (
    <Routes>
      {/* 1. Rotas Públicas */}
      {RoutesLayout()}

      {/* 2. Rotas Administrativas */}
      {RoutesAdmin()}

      {/* 3. Tratamento de Erros e 404 */}
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}